import { render, staticRenderFns } from "./PlusSkills.vue?vue&type=template&id=c0b4a0cc&scoped=true"
import script from "./PlusSkills.vue?vue&type=script&lang=js"
export * from "./PlusSkills.vue?vue&type=script&lang=js"
import style0 from "./PlusSkills.vue?vue&type=style&index=0&id=c0b4a0cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b4a0cc",
  null
  
)

export default component.exports